import React, { useState, useMemo } from "react";
import AddSliderContext from "./AddSliderContext";

const AddSliderState = (props) => {
  const initState = {
    id: "",
    title: "",
    imageUrl: "",
    imageName: "",
    link: "",
    order: 1,
    isActive: true,
  };
  const [state, setState] = useState(initState);

  const value = useMemo(
    () => ({
      state,
      setState,
    }),
    [state]
  );

  return (
    <AddSliderContext.Provider value={value}>
      {props.children}
    </AddSliderContext.Provider>
  );
};

export default AddSliderState;
